<template>
  <section>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          :selectable="isRowSelectable"
        ></el-table-column>
        <el-table-column
          width="69px"
          align="left">
          <template  #default="{ row }">
            <div class="flex-column  flex-align-center">
              <span
                v-if="row.merchant_platform"
                class="table-icon__img mg-b-8">
                <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
              </span>
              <span
                v-tooltip="row.agency_name"
                class="table-icon__img mg-b-8">
                <img
                  :src="getAgencyIcon(row.agency_id)">
              </span>
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="file-powerpoint" />
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="95px"
          label="Created">
          <template
            #header="{column, $index}"
          >
            <span
              class="pointer flex-align-center"
              @click="handleSort(by_sort==1?2:1,column, $index)">
              <span  :class="{'blue':by_sort==1}">Created</span>
              <font-awesome-icon
                v-if="by_sort==1"
                class="mg-l-8"
                icon="arrow-down"></font-awesome-icon>
              <font-awesome-icon
                v-else
                class="mg-l-8"
                icon="arrow-up"></font-awesome-icon>
            </span>
          </template>
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <span>{{ row.created_at.split(" ")[0] }}</span><br>
              <span> {{ row.created_at.split(" ")[1] }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="80">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>
                <!--                <p class="table-type">-->
                <!--                  <span>Renew</span>-->
                <!--                </p>-->
                <div
                  class="flex table-icon"
                  :class="{'ju_center': row.company_id == 0}">
                  <div v-if="row.company_id">
                    <span
                      v-tooltip="row.company_language"
                      class="icon icon-content">
                      <img
                        :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo">
                    </span>
                  </div>
                  <div>
                    <span
                      v-tooltip="row.class_language"
                      class="icon icon-content"
                    >
                      <font-awesome-icon
                        v-if="row.class_id"
                        :icon="getOptionName('iconOptions', row.class_id)" />
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Plan Name">
          <template #default="{ row }">
            <div
              class="flex-algin"
            >
              <div
                class="showLick"
              >
                <span class="span-label">{{ row.plan }}</span>
              </div>
              <p
                v-if="row.quotation_number"
                class="phone-text">
                {{row.quotation_number}}
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="240"
          label="Address">
          <template #default="{ row }">
            <p class="first-text summary">{{ row.export_addr }} </p>
          </template>
        </el-table-column>

        <el-table-column
          width="105px"
          label="Account">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.policy_holder }}</span>
              <span>
                <template v-if="row.identity == 2">
                  {{ row.contact_nm }}
                </template>
                <span class="phone-text"> {{ row.phone_no }}</span>
              </span>
              <p v-if="[0,1].includes(row.pcy_agreement_1)">
                <span class="flex flex-align-center">
                  <font-awesome-icon
                    icon="square-check"
                    class="mg-r-3 fs-12"
                    :class="{'pending_verify-color':row.pcy_agreement_1==0,'verified-color':row.pcy_agreement_1==1} "></font-awesome-icon>
                  <span
                    class="fs-12"
                    :class="{
                      'pending_verify-color': row.pcy_agreement_1 ==0,
                      'verified-color': row.pcy_agreement_1 == 1,
                    }">{{getOptionName('user_agreement_option',row.pcy_agreement_1) }}</span>
                </span>
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Referrer"
          prop="referrer_nm">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.referrer_nm }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="120"
          label="Period">
          <template #default="{ row }">
            <div class="flex-algin period-text">
              <span>{{ row.policy_period.split(" - ")[0] }}&nbsp;-</span><br>
              <span> {{ row.policy_period.split(" - ")[1] }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column
          width="155px"
          label="Mail Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="status-height icon-color">
                <span
                  :class="{
                    'pending_verify-color': [1].includes(row.send_notice_stts),
                    'gray': [4].includes(row.send_notice_stts),
                    'verified-color': [3].includes(row.send_notice_stts),
                    'purple': [2].includes(row.send_notice_stts)
                  }">
                  {{ row.send_notice_stts_language }}
                </span>
              </p>
              <span class="flex">
                <v-button
                  icon="print"
                  gray
                  @click="openUrl(row.notice_url)"></v-button>
                <v-button
                  icon="magnifying-glass"
                  gray
                  @click="showStatusDetail(row)"></v-button>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <v-pagination
        :total="pageConfig.total"
        :current="pageConfig.currentPage"
        @currentChange="currentChange" />
    </div>
    <update-mail-status
      v-model="showMailStatus"
      :form="detail"
      :is-detail="isDetail"
      :status-id-arr="status_list"
      @update="handleUpdate"></update-mail-status>
  </section>
</template>

<script>
import {getRenewalMailList} from '@/api/renewal'
import MixinOptions from '@/mixins/options'
import {downloadFile} from '@/utils/download'
import updateMailStatus from '@/views/renew/components/updateMailStatus'
export default {
  name: 'RenewList',
  components:{
    updateMailStatus
  },
  mixins: [MixinOptions],
  props:{
    filterData:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      tableData: [],
      pageConfig: {
        currentPage: 1,
        total: 10
      },
      multipleSelection:[],
      showMailStatus:false,
      isDetail:false,
      detail:{},
      by_sort:1
    }
  },
  computed:{
    renew_mail_status(){
      let {renew_mail_status} = this.globalOptions
      return renew_mail_status||[]
    },
    status_list(){
      const mail_status_list = this.multipleSelection.reduce((result, item) => {
        result.push(item.renewal_ticket_id)
        return result
      }, [])
      return mail_status_list
    },
    download_list(){
      const mail_status_list = this.multipleSelection.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      return mail_status_list
    }
  },
  watch:{
    status_list:{
      immediate:true,
      handler(val){
        this.$emit('update:statusList',val)
      }
    },
    download_list:{
      immediate:true,
      handler(val){
        this.$emit('update:downList',val)
      }
    }
  },
  mounted(){
    this.network().getRenewalList()
  },
  methods: {
    handleSort(type,cloumn,index){
      this.by_sort = type
      this.network().getRenewalList()
    },
    isRowSelectable(row) {
      return row.send_notice_stts !== 3
    },
    getAgencyIcon(agency_id){
      let obj = {}
      this.agencyStatusOption.filter(item=>{
        if(item.id==agency_id)
          obj = item
      })
      return obj.agency_icon
    },
    showStatusDetail(data){
      this.detail = data
      this.isDetail = true
      this.showMailStatus  = true
    },
    handleChangeStatus(){
      this.isDetail = false
      this.detail ={}
      this.showMailStatus  = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getRenewalList()
    },
    handleUpdate(){
      this.currentChange(1)
    },
    handleMoreDown(params){
      this.network().getRenewalList({is_download:1,...params})
    },
    network(){
      return {
        getRenewalList: async (otherParams) => {
          let params = {
            page: this.pageConfig.currentPage,
            start_expry_dt: this.filterData.start_dt,
            end_expry_dt: this.filterData.end_dt,
            company_id: this.filterData.company_id? [this.filterData.company_id] : null,
            class_id: this.filterData.class_id,
            search: this.filterData.search,
            stts: this.filterData.stts,
            no_need: this.filterData.no_need,
            merchant_platform:this.filterData.merchant_platform,
            pcy_agreement_1:this.filterData.pcy_agreement_1,
            by_sort:this.by_sort==1?'desc':'asc',
            ...otherParams,
          }
          if(otherParams && otherParams.is_download == 1){
            const res = await getRenewalMailList(params,{
              timeout: 120000,
              responseType: 'blob'
            })
            downloadFile(res)
          }
          else if(otherParams && otherParams.is_export == 1){
            const res = await getRenewalMailList(params,{
              responseType: 'blob',
              timeout: 120000
            })
            downloadFile(res)
          }else {
            const {data} = await getRenewalMailList(params)
            this.pageConfig.currentPage = data.current_page
            this.pageConfig.total = data.total
            this.tableData = data.data
          }

        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container {
  position: relative;
  color: #303133;
  .table-type{
    margin-bottom: 6px;
    white-space: nowrap;
    span{
      font-weight: 600;
      font-size: 12px;
      border: 1px solid #6A737D;
      box-sizing: border-box;
      border-radius: 100px;
      padding: 0px 8px;
    }
  }
  .flex-algin {
    &.time-text{
      font-size: 12px;
    }
    .icon-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-left: 15px;
    }
    .phone-text{
      font-size: 12px;
      color: #6A737D;
      .weight-text{
        font-weight: 600;
      }
    }
    &.period-text{
      span{
        font-size: 12px;
      }
    }
    p, span {
      min-height: 20px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;
    }
    .status-height{
      height: 23px;
    }
    .showLick{
      text-decoration: none;
    }
  }
  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  .ju_center{
    justify-content: center;
  }
  .span-name {
    display: block;
    color: #24292E;
    height: auto!important;
    font-size: 14px;
    word-break: break-word;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 600;
    word-break: break-word;
    font-size: 14px;
    text-decoration: none;
    &:hover{
      color:  #0366D6;
    }
  }
  .span-status, .span-options {
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    height: 18px;
    min-height: 18px !important;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.purple {
      background: #6F42C1;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
    &.purple{
      color: #6F42C1;
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      //padding: 10px 15px 10px auto !important;
      vertical-align: top;

      //height: 40px;
      .cell{
        //min-height: 40px;
        line-height: 23px;
        position: relative;
        height: inherit;
        //margin-left: 10px;
        //margin-right: 10px;
        //padding: 0;
        //padding: 5px 10px;
        //position: absolute;
        //top: 10px;
      }
    }
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;

  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    /* Text/text-gray-dark */
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      //padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    //line-height: 30px;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
.verified-color{
  color: #22863a;
}
.pending_verify-color{
  color: #dbab09;
}
</style>
